// extracted by mini-css-extract-plugin
export default {"error":"ClickRichText_error__fbi68","label":"ClickRichText_label__u8Vhg"};